import React, {useState, useEffect} from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import './scss/main.scss';
import Router from './Router';
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  HttpLink,
} from '@apollo/client';
import {STRAPI_DEVELOPMENT, STRAPI_PRODUCTION} from './constants/Api';
import {useSelector, useDispatch} from 'react-redux';
import {getAuthTokenStorage} from './redux/actions/auth';

const App = () => {
  const {authToken} = useSelector((state) => state.Auth);

  const createApolloClient = (authToken) => {
    if (authToken) {
      return new ApolloClient({
        link: new HttpLink({
          uri:
            process.env.NODE_ENV === 'production'
              ? `${STRAPI_PRODUCTION}/graphql`
              : `${STRAPI_DEVELOPMENT}/graphql`,
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }),
        cache: new InMemoryCache(),
      });
    } else {
      return new ApolloClient({
        link: new HttpLink({
          uri:
            process.env.NODE_ENV === 'production'
              ? `${STRAPI_PRODUCTION}/graphql`
              : `${STRAPI_DEVELOPMENT}/graphql`,
        }),
        cache: new InMemoryCache(),
      });
    }
  };

  const [apolloClient, setApolloClient] = useState(createApolloClient());
  useEffect(() => {
    if (authToken) {
      const withToken = createApolloClient(authToken);
      setApolloClient(withToken);
    } else {
      const withOutToken = createApolloClient();
      setApolloClient(withOutToken);
    }
  }, [authToken]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAuthTokenStorage());
  }, []);

  return (
    <ApolloProvider client={apolloClient}>
      <Router />
    </ApolloProvider>
  );
};

export default App;
